<template>
    <Button unstyled :pt="theme" :ptOptions="{
        mergeProps: ptViewMerge
    }">
        <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
            <slot :name="slotName" v-bind="slotProps ?? {}" />
        </template>
    </Button>
</template>

<script setup lang="ts">
import Button, {
    type ButtonPassThroughOptions,
    type ButtonProps,
} from "primevue/button";
import { onMounted, ref } from "vue";
import { ptViewMerge } from "./utils";

interface Props extends /* @vue-ignore */ ButtonProps { }
defineProps<Props>();

const theme = ref<ButtonPassThroughOptions>({
    root: `inline-flex cursor-pointer select-none items-center justify-center overflow-hidden relative
        px-3 py-2 gap-2 rounded-md disabled:pointer-events-none disabled:opacity-60 transition-colors duration-200
        bg-transparent text-white
        focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-[var(--p-primary-500)]
        p-vertical:flex-col p-fluid:w-full p-fluid:p-icon-only:w-10
        p-icon-only:w-10 p-icon-only:px-0 p-icon-only:gap-0
        p-icon-only:p-rounded:rounded-full p-icon-only:p-rounded:h-10
        p-small:text-sm p-small:px-[0.625rem] p-small:py-[0.375rem]
        p-large:text-[1.125rem] p-large:px-[0.875rem] p-large:py-[0.625rem]
        p-raised:shadow-sm p-rounded:rounded-[2rem]
    `,
    loadingIcon: `animate-spin`,
    icon: `p-right:order-1 p-bottom:order-2`,
    label: `font-medium p-icon-only:invisible p-icon-only:w-0
        p-small:text-sm p-large:text-[1.125rem]`,
    pcBadge: {
        root: `min-w-4 h-4 leading-4 bg-white rounded-full text-[var(--p-primary-500)] text-xs font-bold`,
    },
});

// Add custom CSS for router-link-exact-active state
onMounted(() => {
    if (!document.getElementById('volt-nav-button-active-styles')) {
        const style = document.createElement('style');
        style.id = 'volt-nav-button-active-styles';
        style.textContent = `
            .router-link-active button {
                background-color: white !important;
                color: var(--p-primary-500) !important;
            }

            .router-link-active button:hover:enabled {
                background-color: white !important;
                color: var(--p-primary-500) !important;
            }
        `;
        document.head.appendChild(style);
    }
});
</script>
